import angular from 'angular';

export const AfastadosListRouting = [
    '$stateProvider',
    function ($stateProvider: angular.ui.IStateProvider) {
        $stateProvider
            .state('relatorios_afastados', {
                url: '/relatorios/afastados',
                template: require('html-loader!./index/afastados.index.html'),
                controller: 'AfastadosIndexController',
                controllerAs: 'rltr_fstds_cntrllr'
            });
    }
];
